import React, { useRef } from 'react';
import { theme } from '../../../theme';
import { useEChartsLifecycle, STD_TOOLTIP_STYLE } from './_chartCommon';

// <purpose>Tag.Balken — lollipop chart: 1.5px stems + scatter cap dots. Caps fill on hover.</purpose>

type Props = {
  data: Array<{ date: string; count: number }>;
  filterHash?: string;
};

export const TagBalken: React.FC<Props> = ({ data, filterHash }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const NAVY = theme.colors.navy;
  const NAVY_MID = theme.colors.navyMid;

  useEChartsLifecycle(containerRef, chart => {
    const values = data.map(d => d.count);
    const labels = data.map(d => d.date);

    chart.setOption({
      grid: { left: 36, right: 16, top: 24, bottom: 26 },
      tooltip: {
        ...STD_TOOLTIP_STYLE,
        trigger: 'axis',
        axisPointer: { type: 'line', lineStyle: { color: NAVY, opacity: 0.35, width: 1 } },
        // prefer cap series value; fallback to first
        formatter: (params: any) => {
          const arr = Array.isArray(params) ? params : [params];
          const p = arr.find((x: any) => x.seriesName === 'cap') ?? arr[0];
          if (!p) return '';
          return `<div style="font-size:10px;color:#888">${p.axisValue}</div><div style="font-size:14px;color:${NAVY};font-weight:600">${p.value} <span style="font-size:10px;font-weight:400;color:#888">Tickets</span></div>`;
        },
      },
      xAxis: {
        type: 'category',
        data: labels,
        axisLine: { lineStyle: { color: '#dde0e8' } },
        axisTick: { show: false },
        axisLabel: { color: '#9095a3', fontSize: 8, interval: Math.max(0, Math.floor(data.length / 8) - 1) },
      },
      yAxis: {
        type: 'value',
        splitLine: { lineStyle: { color: '#f1f2f6' } },
        axisLabel: { color: '#9095a3', fontSize: 9 },
        axisLine: { show: false },
        axisTick: { show: false },
      },
      series: [
        {
          name: 'stem',
          type: 'bar',
          data: values,
          barWidth: 2,
          itemStyle: { color: NAVY_MID, opacity: 0.7 },
          emphasis: { itemStyle: { opacity: 1 } },
          z: 2,
        },
        {
          name: 'cap',
          type: 'scatter',
          data: values,
          symbolSize: 8,
          itemStyle: { color: 'white', borderColor: NAVY, borderWidth: 1.5 },
          emphasis: {
            itemStyle: { color: NAVY, borderColor: 'white', borderWidth: 1.5, shadowColor: 'rgba(6,16,90,0.45)', shadowBlur: 10 },
            scale: 1.4,
          },
          z: 3,
        },
      ],
    });
  }, [data, filterHash]);

  return <div ref={containerRef} style={{ width: '100%', height: 220 }} />;
};
